import React from 'react';

const LoginPage = ({ login, setLogin, handleLogin, loginError }) => {
  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <section className="card login-card">
      <div className="login-layout">
        <div className="login-side">
          <div className="login-badge">B2B Admin Access</div>
          <h2>Welcome Back</h2>
          <p className="muted">Sign in to manage catalog, orders, approvals, inventory, and notifications.</p>
          <div className="login-points">
            <div className="login-point">
              <strong>Catalog Control</strong>
              <span>Manage product data, variants, and media in one workflow.</span>
            </div>
            <div className="login-point">
              <strong>Order Operations</strong>
              <span>Track wholesale order status and processing actions.</span>
            </div>
            <div className="login-point">
              <strong>Retailer Management</strong>
              <span>Handle approvals, pricing visibility, and communication.</span>
            </div>
          </div>
        </div>

        <form className="login-details" onSubmit={onSubmit}>
          <div className="row login-details-head">
            <h3>Login Details</h3>
            <span className="badge-soft">Admin Only</span>
          </div>
          <div className="login-fields">
            <div>
              <label>Email</label>
              <input
                type="email"
                placeholder="admin@company.com"
                value={login.email}
                onChange={(e) => setLogin({ ...login, email: e.target.value })}
              />
            </div>
            <div>
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter password"
                value={login.password}
                onChange={(e) => setLogin({ ...login, password: e.target.value })}
              />
            </div>
          </div>
          {loginError ? <div className="error">{loginError}</div> : null}
          <div className="row login-actions">
            <button type="submit">Sign In</button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default LoginPage;
